// extracted by mini-css-extract-plugin
export default {"dropArea":"styles_dropArea__5ORAK"};